import $ from 'cash-dom';
import algoliasearch from 'algoliasearch';
import { trackEvent } from '@usafacts/frontend-library-utils/googleAnalytics';
import aa from 'search-insights';

// https://github.com/algolia/algoliasearch-client-javascript
const applicationId = '2HYPB2F2D4';
const apiKey = '288ffc465a8c1195c30b8c2606dbce4a';
const client = algoliasearch(applicationId, apiKey);
const prefix = document.querySelector('meta[name="algolia-prefix"]').content;
const fetchSuggestions = async function () {
  let query = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
  const indices = [`${prefix}_cms`, `${prefix}_main`];
  const queryProps = {
    getRankingInfo: true,
    analytics: true,
    hitsPerPage: 10,
    facetFilters: [],
    optionalFilters: [`title:${query}`],
    replaceSynonymsInHighlight: true
  };
  const catcher = () => ({});
  const indexesQueries = indices.map(index => {
    const currentIndex = client.initIndex(index);
    return currentIndex.search(query, queryProps).catch(catcher).then(answer => answer === null || answer === void 0 ? void 0 : answer.hits);
  });
  return Promise.all(indexesQueries);
};
function suggestionTemplate(suggestion, position) {
  // for the categories in here we use isNaN to only display
  // tags that cannot be cast into integers
  $(document).on('click', `#object-${suggestion.objectID}`, () => {
    aa('clickedObjectIDsAfterSearch', {
      userToken: 'user-1',
      eventName: 'clicked_on_search_result',
      index: 'clicked_on_search_result',
      queryID: suggestion.queryID,
      objectIDs: [suggestion.objectID],
      positions: [position]
    });
    trackEvent('Search Result Click', 'SearchResult', suggestion.url);
  });
  return `
    <a class="aa-suggestion-link uk-link-reset" id="${`object-${suggestion.objectID}`}" href="${suggestion.url}">
      <span class="aa-suggestion aa-suggestion-title">${suggestion._highlightResult.title.value}</span>
        ${suggestion.search_category ? `
        <span class="aa-suggestion-categories">
          <span>${suggestion.search_category}</span>
        </span>
      ` : ''}
    </a>
  `;
}
export default function Search() {
  aa('init', {
    appId: applicationId,
    apiKey
  });
  const searchField = $('#search-field');
  const searchResults = $('#search-results');
  const searchMissing = $('#search-missing');
  const searchFooter = $('#search-footer');
  const searchToggle = $('.search__toggle');
  const searchForm = $('.search__form');
  const searchClose = $('.search__close');
  const body = $('body');
  const seeAllLink = $('.see-all-link');
  const sortByUserRank = newOptions => {
    if (!newOptions) return newOptions;
    return newOptions.sort((a, b) => {
      /* eslint-disable no-underscore-dangle */
      const aRanked = a._rankingInfo.userScore;
      const bRanked = b._rankingInfo.userScore;
      /* eslint-enable no-underscore-dangle */
      if (aRanked < bRanked) return -1;
      if (aRanked > bRanked) return 1;
      return 0;
    });
  };
  const onSearchChanged = query => {
    searchResults.empty();
    fetchSuggestions(query).catch(() => []).then(results => {
      const flatResults = results.flat();
      if (flatResults.length > 0) {
        sortByUserRank(flatResults).forEach((x, i) => searchResults.append(suggestionTemplate(x, i)));
        searchFooter.show();
        searchResults.show();
        searchMissing.hide();
      } else {
        searchMissing.show();
        searchFooter.hide();
      }
    });
  };
  const debounce = (func, wait) => {
    let timeout;
    return function executedFunction() {
      for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }
      const later = () => {
        clearTimeout(timeout);
        func(...args);
      };
      clearTimeout(timeout);
      timeout = setTimeout(later, wait);
    };
  };
  const onSearchChangedDebounced = debounce(onSearchChanged, 300);
  const reset = () => {
    searchField.empty();
    searchResults.empty();
    searchMissing.hide();
    searchFooter.hide();
  };
  searchField.on('keyup', e => {
    if (searchField.val()) {
      searchForm.addClass('is-open');
      body.addClass('is-menuopen');
    } else {
      searchForm.removeClass('is-open');
      body.removeClass('is-menuopen');
    }
    onSearchChangedDebounced(e.target.value);
    seeAllLink.attr('href', `/search/?query=${e.target.value}`);
  }).on('click', () => {
    trackEvent('Search Bar Click', 'Search Bar', window.location);
  }).on('search', () => {
    reset();
  });
  searchToggle.on('click touchend', e => {
    if (!searchForm.hasClass('is-open')) {
      const input = document.getElementById('search-field');
      input.focus();
      input.setSelectionRange(0, 0);
      searchForm.addClass('is-open');
      body.addClass('is-menuopen');
    }
    e.preventDefault();
  });
  searchClose.on('click touchend', e => {
    searchForm.removeClass('is-open');
    body.removeClass('is-menuopen');
    e.preventDefault();
  });
  reset();
}